import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M9.678 2.651a.5.5 0 0 0-.552.136L7.751 4.334a.252.252 0 0 1-.391-.021L5.407 1.578a.52.52 0 0 0-.814 0L2.64 4.313a.252.252 0 0 1-.391.021L.874 2.787A.5.5 0 0 0 0 3.119v5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.322-.468"
    }, null, -1)
  ]));
}
const interfaceAwardCrown = { render };
export {
  interfaceAwardCrown as default,
  render
};
//# sourceMappingURL=interface-award-crown.svg.js.map
